import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { ThemeService } from './shared/services/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, SidebarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  showSidebar = false;
  blacklistRoutes: string[] = ['', 'login'];

  // ThemeService injected here to guarantee initialization before any route renders
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    readonly themeService: ThemeService
  ) {}

  ngOnInit() {
    this.router.events.subscribe(() => {
      const firstChild = this.route.snapshot.firstChild;
      if (firstChild?.routeConfig) {
        const currentRoute = firstChild.routeConfig.path;
        this.showSidebar = typeof currentRoute === 'string' ? !this.blacklistRoutes.includes(currentRoute) : true;
      } else {
        this.showSidebar = true;
      }
    });
  }
}
